/**
 * Normalize socket tick payloads — server may send JSON strings, objects, or positional arrays.
 */

export function normalizeTickPayload(raw) {
  let data = raw;
  if (data == null) return null;

  if (typeof data === "string") {
    const s = data.trim();
    if (!s) return null;
    try {
      data = JSON.parse(s);
    } catch {
      return null;
    }
  }

  if (Array.isArray(data) && data.length > 3) {
    return {
      Script: data[1],
      LTP: Number(data[2]),
      Bid: Number(data[7] ?? 0),
      Ask: Number(data[8] ?? 0),
      PrevClose: Number(data[13] ?? data[12] ?? 0),
      Low: Number(data[12] ?? 0),
      High: Number(data[11] ?? 0),
      Open: Number(data[10] ?? 0),
      Vol: data[4],
    };
  }

  if (typeof data === "object" && !Array.isArray(data)) {
    const Script =
      data.Script ??
      data.script ??
      data.SCRIPT ??
      data.Symbol ??
      data.symbol ??
      data.Token ??
      data.token ??
      data.instrumentToken ??
      data.InstrumentToken ??
      data.securityId ??
      data.SecurityId;
    if (Script != null && String(Script).trim() !== "" && !data.Script && !data.script) {
      return { ...data, Script: String(Script).trim() };
    }
    return data;
  }

  return null;
}
